import { onUnmounted, watchEffect } from 'vue'
import usePersistedConfigStore from '@shared/stores/usePersistedConfigStore.js'
import { useRoute } from 'vue-router'

export const META_PIXELS = {
  uhc: '915852080167099',
  westernhealth: '1506526123699918',
  wellwisconsin: '733220583066567',
}

export default function useMetaPixel(metaPixel) {
  const persistedConfigStore = usePersistedConfigStore()
  const route = useRoute()

  const loadPixel = () => {
    if (!window.fbq && !document.getElementById('fb-pixel-script')) {
      const script = document.createElement('script')
      script.id = 'fb-pixel-script'
      script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
    `
      document.head.appendChild(script)
    }

    if (persistedConfigStore.targetingEnabled) {
      window.fbq?.('consent', 'grant')
    } else {
      window.fbq?.('consent', 'revoke')
    }

    window.fbq?.('init', metaPixel)
    window.fbq?.('track', 'PageView', {
      content_name: route.params.corporate_key,
    })

    if (
      !window.fbq ||
      !document.querySelector('script[src*="connect.facebook.net"]')
    ) {
      console.warn('Meta Pixel failed to load or was blocked by CSP')
    }
  }

  const unloadPixel = () => {
    window.fbq?.('consent', 'revoke')
    document.getElementById('fb-pixel-script')?.remove()
    document
      .querySelectorAll('script[src*="connect.facebook.net"]')
      .forEach((s) => s.remove())
    window.fbq = undefined
    delete window.fbq
  }

  const rejectPixel = () => {
    // remove cookies
    document.cookie = '_fbp=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    document.cookie = 'c_user=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    document.cookie = 'datr=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    document.cookie = 'oo=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    document.cookie = 'sb=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    document.cookie = 'wd=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    document.cookie = 'xs=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
  }

  const cspViolationHandler = (event) => {
    if (event.target.id === 'fb-pixel-script')
      console.warn('CSP Violation while loading the meta pixel:', event)
  }

  window.addEventListener('securitypolicyviolation', cspViolationHandler)

  watchEffect(() => {
    if (persistedConfigStore.targetingEnabled === null) return
    if (persistedConfigStore.targetingEnabled) {
      loadPixel()
    } else {
      unloadPixel()
      rejectPixel()
    }
  })

  onUnmounted(() => {
    unloadPixel()
    window.removeEventListener('securitypolicyviolation', cspViolationHandler)
  })
}
